export const EXAM_TIMETABLE_CSV_HEADERS = [
  'class_name',
  'subject_name',
  'max_marks',
  'exam_date',
  'start_time',
  'end_time',
  'room',
] as const;

export { triggerCsvDownload } from './csvDownload';

function escapeCsvCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function splitCsvLine(line: string): string[] {
  const out: string[] = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          cur += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        cur += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      out.push(cur);
      cur = '';
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
}

function joinCsvLine(cells: string[]): string {
  return cells.map((cell) => escapeCsvCell(cell)).join(',');
}

export function buildExamTimetableQuery(params: {
  examId: string;
  term: string;
  academicYear: string;
  classId?: string;
  examDate?: string;
}): string {
  const qs = new URLSearchParams({
    exam_id: params.examId,
    term: params.term,
    academic_year: params.academicYear,
  });
  if (params.classId) qs.set('class_id', params.classId);
  if (params.examDate?.trim()) qs.set('exam_date', params.examDate.trim());
  return qs.toString();
}

/** Fill blank exam_date cells with the selected form date (YYYY-MM-DD). */
export function enrichExamTimetableTemplateCsv(
  csv: string,
  options: { examDate?: string }
): string {
  const sampleDate = options.examDate?.trim();
  if (!sampleDate) return csv;

  const lines = csv.split(/\r?\n/);
  const output: string[] = [];
  let headerMap: Record<string, number> | null = null;
  let filledFirstRow = false;

  for (const rawLine of lines) {
    const trimmed = rawLine.trim();
    if (!trimmed) {
      output.push(rawLine);
      continue;
    }

    const cells = splitCsvLine(rawLine);
    if (!headerMap) {
      headerMap = {};
      cells.forEach((header, index) => {
        headerMap![header.trim().toLowerCase()] = index;
      });
      output.push(joinCsvLine(cells));
      continue;
    }

    const dateIndex = headerMap.exam_date;
    if (dateIndex === undefined) {
      output.push(joinCsvLine(cells));
      continue;
    }

    const currentDate = (cells[dateIndex] ?? '').trim();
    if (!currentDate) {
      cells[dateIndex] = sampleDate;
      if (!filledFirstRow) filledFirstRow = true;
    }
    output.push(joinCsvLine(cells));
  }

  return `${output.join('\n')}\n`;
}
